export const buildOrgStatusInfoMap = (nodes = []) => {
  const map = new Map();

  const visit = (items) => {
    (items || []).forEach((node) => {
      const id = node.id || node._id || node.key;
      if (id && node.status) {
        map.set(String(id), {
          status: node.status,
          inactiveDate: node.inactiveDate ?? null,
        });
      }
      if (node.children?.length) {
        visit(node.children);
      }
    });
  };

  visit(nodes);
  return map;
};

export const findOrgPathWithStatus = (nodes, targetId) => {
  if (!targetId) return [];
  for (const node of nodes || []) {
    if (String(node?.id) === String(targetId)) {
      return [
        {
          id: node.id,
          name: node.name || String(node.id),
          status: node.status,
          inactiveDate: node.inactiveDate ?? null,
        },
      ];
    }
    const childPath = findOrgPathWithStatus(node?.children, targetId);
    if (childPath.length) {
      return [
        {
          id: node.id,
          name: node.name || String(node.id),
          status: node.status,
          inactiveDate: node.inactiveDate ?? null,
        },
        ...childPath,
      ];
    }
  }
  return [];
};

export const enrichOrgTreeWithStatus = (tree = [], statusMap = new Map()) => {
  if (!Array.isArray(tree)) return tree;

  return tree.map((node) => {
    const id = String(node?.id || node?._id || node?.key || "");
    const status = statusMap.get(id);

    return {
      ...node,
      status: status || node.status,
      children: node.children
        ? enrichOrgTreeWithStatus(node.children, statusMap)
        : undefined,
    };
  });
};

export const loadOrgHierarchyWithStatus = async (organizationService) => {
  const data = await organizationService.fetchHierarchy();
  let tree = Array.isArray(data?.tree) ? data.tree : [];

  const statusMap = new Map();
  if (Array.isArray(data?.items)) {
    data.items.forEach((unit) => {
      if (unit?.id && unit?.status) {
        statusMap.set(String(unit.id), unit.status);
      }
    });
  }

  if (statusMap.size > 0) {
    tree = enrichOrgTreeWithStatus(tree, statusMap);
  }

  return tree;
};

export const buildOrgNameToStatusInfoMap = (nodes = []) => {
  const map = new Map();
  const walk = (items = []) => {
    items.forEach((node) => {
      if (node?.name && node?.status) {
        map.set(node.name, {
          status: node.status,
          inactiveDate: node.inactiveDate ?? null,
        });
      }
      if (Array.isArray(node?.children)) {
        walk(node.children);
      }
    });
  };
  walk(nodes);
  return map;
};
